export default "__VITE_ASSET__QD$BQOT$__"